export default __webpack_public_path__ + "static/media/Yuk1.9eef542e.JPG";